import { memo, useEffect, useState } from 'react';
import { PropTypes } from 'prop-types';
import { CFD_SHORT_NAME, ETF_SHORT_NAME, MODAL_SIZES } from 'shared-modules/constants';
import { CFD_VALUE, ETF_VALUE } from 'shared-modules/constants/core';
import { getInstrumentInfo } from 'shared-modules/api/instrumentInfoApi';
import { useDispatch } from 'react-redux';
import { callErrorHandler } from 'shared-modules/redux/actions/errorActions';
import styles from './instrumentInfoModal.module.scss';
import { Button, Modal, Spin } from '../../../../components';
import { closeInstrumentInfoModal } from '../../../../redux/actions';

const columns = [
  { label: '参照原資産', key: 'underlyingAsset' },
  { label: '取引所', key: 'exchange' },
  { label: '通貨', key: 'conversion' },
  { label: '最小取引数量', key: 'unit' },
  { label: 'レバレッジ', key: 'leverage' },
  { label: '取引時間', key: 'exchangeTime' },
  { label: '特徴', key: 'summary' },
];

const SERVICE_NAME = {
  [ETF_VALUE]: ETF_SHORT_NAME, // CFDをつけない
  [CFD_VALUE]: CFD_SHORT_NAME, // CFDをつけない
};

const InstrumentInfoModal = ({ isOpen, closeModal, instrumentInfoId, serviceId }) => {
  const dispatch = useDispatch();
  const [data, setData] = useState(null);
  const title = data?.shortName;

  useEffect(() => {
    if (!serviceId || !instrumentInfoId) {
      return;
    }
    setData(null);
    (async () => {
      try {
        const result = await getInstrumentInfo({ serviceId, instrumentInfoId });
        if (result?.data?.[0]) {
          setData(result.data[0]);
        }
      } catch (error) {
        dispatch(callErrorHandler({ error }));
        dispatch(closeInstrumentInfoModal());
      }
    })();
  }, [dispatch, instrumentInfoId, serviceId]);

  return (
    <Modal isOpen={isOpen} closeModal={closeModal} title={title} size={MODAL_SIZES.WIDTH_512}>
      {!data && (
        <div className={styles.loaderContainer}>
          <Spin />
        </div>
      )}
      {data && (
        <div className={styles.contentMain}>
          <div className={styles.badges}>
            <div className={styles.badge}>{SERVICE_NAME[data.serviceId]}</div>
            {data.serviceId === ETF_VALUE && <div className={styles.badge}>{data.symbol}</div>}
          </div>
          <ul className={styles.table}>
            {columns.map((col) => (
              <li key={col.key}>
                <div className={styles.label}>{col.label}</div>
                <div className={styles.value}>{data[col.key]}</div>
              </li>
            ))}
          </ul>
          {data?.url && (
            <div className={styles.footer}>
              <Button secondary className={styles.urlBtn} onClick={() => window.open(encodeURI(data.url), '_blank')}>
                詳細
              </Button>
            </div>
          )}
        </div>
      )}
    </Modal>
  );
};

InstrumentInfoModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  serviceId: PropTypes.string.isRequired,
  instrumentInfoId: PropTypes.string.isRequired,
};

export default memo(InstrumentInfoModal);
